import api from '@/api';
import { PageRequest } from '@/core/request/PageRequest';
import {
  QuotationConfigurationResponse,
  QuotationGeneratePurchaseRequest,
  QuotationOffersResponse,
  QuotationOffersWinnersRequest,
  QuotationSuppliersOffers,
  QuotationsConfigurationQuery,
  SendQuotationOffersRequest,
} from './QuotationsOffers.types';
import { API_BASE_URL } from '..';
import { PageResultStock } from '@/core/request/PageResultStock';

const CONTROLLER_URL = `${API_BASE_URL}/quotations`;

export async function getQuotationOffers(
  quotationId: number,
  params: PageRequest,
): Promise<PageResultStock<QuotationOffersResponse>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${quotationId}/offers`,
    params,
  )) as unknown;

  return result as PageResultStock<QuotationOffersResponse>;
}

export async function listQuotationsConfiguration(
  params?: QuotationsConfigurationQuery,
): Promise<PageResultStock<QuotationConfigurationResponse>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${params?.quotationId}/offers/configuration`,
    params,
  )) as unknown;

  return result as PageResultStock<QuotationConfigurationResponse>;
}

export async function sendQuotationOffersConfiguration(
  obj: SendQuotationOffersRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.quotationId}/offers/configuration`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function createQuotationOffersWinners(
  obj: QuotationOffersWinnersRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${obj.quotationId}/offers/winners`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function getQuotationListOffersSelect(
  quotationId?: number,
  params?: PageRequest,
): Promise<PageResultStock<QuotationSuppliersOffers>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${quotationId}/select-offers`,
    params,
  )) as unknown;

  return result as PageResultStock<QuotationSuppliersOffers>;
}

export async function createQuotationGeneratePurchase(
  obj: QuotationGeneratePurchaseRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${obj.quotationId}/offers/purchase`,
    obj,
    null,
  )) as unknown;

  return result;
}
